import { handleApi } from "../common";

const API_ENTPOINTS = {
	NEWS_DETAILS: 'api/equity/api/eqm/wave/market/get_sector_wise_news_details',
	HOT_PURSUIT: '/api/equity/api/eqm/wave/market/get_hot_pursuit_data',
	ANNOUNCEMENTS: 'api/equity/api/eqm/wave/market/get_announcements_data',
	NEWS_DATA: 'api/equity/api/eqm/wave/market/get_news_data',
	SECTOR_LIST: 'api/equity/api/eqm/wave/market/get_sector_list',
	SECTORWISE_NEWS_DATA: 'api/equity/api/eqm/wave/market/get_sector_wise_news_data',
	YOUR_PORTFOLIO_NEWS: '/api/equity/api/eqm/wave/market/get_hot_pursuit_data', // TODO: update this with portfolio news api
};

export const fetch_hot_pursuit_data = async (Api, data) => {
	const response = await Api.post(API_ENTPOINTS.HOT_PURSUIT, data);
	return handleApi(response);
};

//TODO: update this function as per your portfolio api
export const fetch_portfolio_news_data = async (Api, data) => {
	const response = await Api.post(API_ENTPOINTS.YOUR_PORTFOLIO_NEWS, data);
	return handleApi(response);
};

export const fetch_announcements = async (Api, data) => {
	const response = await Api.post(API_ENTPOINTS.ANNOUNCEMENTS, data);
	return handleApi(response);
};

export const fetch_news_details = async (Api, data) => {
	const response = await Api.post(API_ENTPOINTS.NEWS_DETAILS, data);
	return handleApi(response);
};

export const fetch_news_data = async (Api, data) => {
	const response = await Api.post(API_ENTPOINTS.NEWS_DATA, data);
	return handleApi(response);
};

export const fetch_sector_list = async (Api, data) => {
	const response = await Api.post(API_ENTPOINTS.SECTOR_LIST, data);
	return handleApi(response);
};

export const fetch_sector_news_data = async (Api, data) => {
	const response = await Api.post(API_ENTPOINTS.SECTORWISE_NEWS_DATA, data);
	return handleApi(response);
};
